import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { profileAPI, videoCallAPI } from '../services/api';
import Sidebar from './Sidebar';
import IncomingCallModal from './IncomingCallModal';
import './Layout.css';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [incomingCall, setIncomingCall] = useState(null);

  useEffect(() => {
    // Update activity immediately on mount
    profileAPI.updateActivity().catch(() => {});

    // Update activity every 30 seconds while user is active
    const activityInterval = setInterval(() => {
      profileAPI.updateActivity().catch(() => {});
    }, 30000); // 30 seconds
    
    // Poll for incoming calls every 3 seconds
    const callInterval = setInterval(() => {
      checkForIncomingCalls();
    }, 3000); // 3 seconds
    
    // Check immediately on mount
    checkForIncomingCalls();
    
    return () => {
      clearInterval(activityInterval);
      clearInterval(callInterval);
    };
  }, []);

  const checkForIncomingCalls = async () => {
    try {
      const response = await videoCallAPI.getPendingCall();
      if (response.data && response.data.id) {
        setIncomingCall(response.data);
      }
    } catch (err) {
      // Silently ignore - 404 means no pending call, which is normal
    }
  };

  const handleAnswerCall = async (call) => {
    setIncomingCall(null);

    // Navigate immediately for better UX - the call screen handles the connection
    navigate(`/call/${call.id}`);

    // Answer the call in the background
    try {
      await videoCallAPI.answerCall(call.id);
    } catch (err) {
      // The call screen will surface any connection issues
    }
  };

  const handleDeclineCall = () => {
    setIncomingCall(null);
  };

  const handleCallTimeout = async () => {
    if (incomingCall) {
      try {
        await videoCallAPI.noAnswer(incomingCall.id);
      } catch (err) {
        // Non-critical
      }
    }
    setIncomingCall(null);
  };

  return (
    <div className="layout">
      <Sidebar />
      <div className="layout-content">
        {/* Incoming Call Modal */}
        {incomingCall && (
          <IncomingCallModal
            call={incomingCall}
            onAnswer={handleAnswerCall}
            onDecline={handleDeclineCall}
            onTimeout={handleCallTimeout}
          />
        )}

        {children}
      </div>
    </div>
  );
};

export default Layout;
